import { AntragsSheetContent } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/AntragsSheetContent';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';

export class SheetContent<TProps = Record<string, unknown>> {
  public contentComponent: React.ComponentType<TProps>;
  public props?: TProps;

  constructor({
    contentComponent,
    props,
  }: {
    contentComponent: React.ComponentType<TProps>;
    props: TProps;
  }) {
    this.contentComponent = contentComponent;
    this.props = props;
  }
}

export class SchichttauschAntragsContent extends SheetContent<{
  antrag: SchichttauschAntrag;
}> {
  constructor({ antrag }: { antrag: SchichttauschAntrag }) {
    super({
      contentComponent: AntragsSheetContent,
      props: { antrag },
    });
  }
}
